import { AsyncPipe } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  DestroyRef,
  inject,
  Input,
  OnInit,
  output,
  signal,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ensureArray, isNonNullish } from '@epicuro-next/utilities';
import { BehaviorSubject, combineLatest, filter, switchMap } from 'rxjs';

import { TypewriterService } from '../service/type-writer.service';

@Component({
  selector: 'atx-type-writer',
  imports: [AsyncPipe],
  templateUrl: './ataraxia-type-writer.component.html',
  styleUrls: ['./ataraxia-type-writer.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [TypewriterService],
})
export class AtaraxiaTypeWriterComponent implements OnInit {
  private readonly titles$ = new BehaviorSubject<string[] | null>(null);
  private readonly writeSpeed$ = new BehaviorSubject<number | undefined>(
    undefined,
  );
  private readonly writeDelay$ = new BehaviorSubject<number | undefined>(
    undefined,
  );
  private readonly destroyRef = inject(DestroyRef);
  private readonly typeWriter = inject(TypewriterService);
  public readonly hideCursorAfterComplete = signal(false);

  @Input()
  public set titles(values: string[] | string) {
    this.titles$.next(ensureArray(values));
  }

  @Input()
  public set writeSpeed(value: number) {
    this.writeSpeed$.next(value);
  }

  @Input()
  public set writeDelay(value: number) {
    this.writeDelay$.next(value);
  }

  public witterComplete = output();

  public readonly typeWriterText$ = combineLatest([
    this.titles$.pipe(filter(isNonNullish)),
    this.writeSpeed$,
    this.writeDelay$,
  ]).pipe(
    switchMap(([titles, writeSpeed, writeDelay]) => {
      return this.typeWriter.typewriterEffect(titles, {
        writeSpeed,
        writeDelay,
      });
    }),
  );

  public ngOnInit() {
    this.typeWriter.complete$
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe(() => {
        this.witterComplete.emit();
        this.hideCursorAfterComplete.set(true);
      });
  }
}
